var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "bg-f3",
      staticStyle: { "min-height": "900px" },
      attrs: { "element-loading-text": "加载中" }
    },
    [
      _c("contract_sign", {
        ref: "contract_sign_dialog",
        on: { buttonSubmit: _vm.buttonSubmit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }